module.exports = __webpack_public_path__ + "static/img/TH.fa61d891.png";